import { MyLeaveInitialState } from "../../../types/hr/hrInterface";
import { HrActionTypes, HrActions } from "../../actionTypes/hr/hrActionTypes";

const initialState: MyLeaveInitialState = {
  myLeaveList: [],
  myLeaveData: {
    id: 0,
    status: "",
    from_date: undefined,
    to_date: undefined,
    employee_id: 0,
    remarks: "",
    reason: "",
    created_by: 0,
  },
  myLeaveListPageCount: 0,
};

export default function myLeaveReducer(state = initialState, action: HrActionTypes): MyLeaveInitialState {
  switch (action.type) {
    
    case HrActions.SET_MY_LEAVE_LIST:
    return {
      ...state,
      myLeaveList: action.payload,
    };

  case HrActions.SET_MY_LEAVE_LIST_PAGE_COUNT:
    return {
      ...state,
      myLeaveListPageCount: action.payload,
    };

  // case HrActions.SET_LEAVE_DATA:
  //   return {
  //     ...state,
  //     myLeaveData: action.payload,
  //   };

    default:
      return state;
  }
}
